/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Validation_Price_NonnegativeInputs */

const vi_order_validation_price_nonnegative = /** @type {(inputs: Order_Validation_Price_NonnegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giá không được âm`)
};

/**

* @param {Order_Validation_Price_NonnegativeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_validation_price_nonnegative = /** @type {((inputs?: Order_Validation_Price_NonnegativeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Validation_Price_NonnegativeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_validation_price_nonnegative(inputs)
});